export const IMG_SIZE = '18px'
export const ICON_SIZE = 10
